<template>
  <div class="publishLazad">
    <div class="center">
      <div class="desctext">{{$t('other.a3090')}}</div>
      <div class="hgfb">
        <span>{{$t('other.a288')}}：</span>
        <el-select size="mini" @change="getCategory()" v-model="shopId" :placeholder="$t('other.a50')">
          <el-option
            v-for="item in tiktokShops"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="tips">{{$t('other.a2881')}}</span>
      </div>
      <div class="categoryDesc">
        <div>
          <span class="categoryname">{{$t('other.a2882')}}:</span>
          <span class="categoryname" v-for="(item,index) in categoryname " :key="index">
            {{item}}
            <span v-show="item">/</span>
          </span>
        </div>
        <div
          class="cateGory"
          v-show="hideCategory"
          @click="categoryname=[],
        categoryId=[],
        hideCategory=false"
        >{{$t('other.a3091')}}</div>
      </div>

      <div class="categoryWrapper" v-if="!hideCategory">
        <div>
          <el-scrollbar class="boxwrapper">
            <div
              class="ingk"
              @click="addItem(firstItem,1)"
              v-for="(firstItem,index) in categorylist"
              :key="index"
            >
              <span class="name">{{firstItem.localDisplayName}}</span>
              <span class="bkng"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div
              class="ingk"
              @click="addItem(firstItem,2)"
              v-for="(firstItem,index) in categorylistTwo"
              :key="index"
            >
              <span class="name">{{firstItem.localDisplayName}}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div
              class="ingk"
              @click="addItem(firstItem,3)"
              v-for="(firstItem,index) in categorylistThree"
              :key="index"
            >
              <span class="name">{{firstItem.localDisplayName}}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div
              class="ingk"
              @click="addItem(firstItem,4)"
              v-for="(firstItem,index) in categorylistfour"
              :key="index"
            >
              <span class="name">{{firstItem.localDisplayName}}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
        <div>
          <el-scrollbar class="boxwrapper">
            <div
              class="ingk"
              @click="addItem(firstItem,5)"
              v-for="(firstItem,index) in categorylistfive"
              :key="index"
            >
              <span class="name">{{firstItem.localDisplayName}}</span>
              <span class="bkng" v-show="firstItem.children"></span>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div>
        <h2>{{$t('other.a3092')}}</h2>
        <div class="iopr">
          <span>{{$t('other.a3093')}}：</span>
          <span v-if="!showFormula && !setFromul">
            {{$t('other.a3094')}}，
            <span style="color:red" @click="showFormula=true">{{$t('other.a3095')}}</span>
          </span>
          <span v-if="showFormula">
            <el-input class="okvn" size="medium" v-model="formula.outBoundFee" :placeholder="$t('other.a910')" />-
            <el-input class="okvn" size="medium" v-model="formula.rate" :placeholder="$t('other.a268')" />-
            <el-input class="okvn" size="medium" v-model="formula.discount" :placeholder="$t('other.a271')" />-
            <el-input class="okvn" size="medium" v-model="formula.profitRate" :placeholder="$t('other.a1685')" />
            <el-button
              style="margin-left:10px;"
              type="primary"
              size="medium"
              @click="countPrice()"
            >{{$t('other.a3096')}}</el-button>
            <el-button type="info" size="medium" @click="showFormula=false">{{$t('other.a146')}}</el-button>
          </span>
          <span v-if="setFromul">
            （{{$t('other.a219')}} + {{formula.outBoundFee}}({{$t('other.a910')}})） / {{$t('other.a268')}}:{{formula.rate}} / {{1 - formula.profitRate/100}}（{{$t('other.a301')}}） / {{(100-formula.discount)/100}}（{{$t('other.a271')}}）
            <span
              style="color:red"
              @click="canCelFormula()"
            >{{$t('other.a1449')}}</span>
          </span>
        </div>
        <div style="color:#999999;margin-top:8px;padding-left:15px;">
          {{$t('other.a3097')}}



        </div>
      </div>
      <List :dataList="dataList" ref="listRef" @updateTemple="updateTemple" />
      <div class="footer">
        <el-button type="primary" @click="saveTempleInfo()">{{$t('other.a3098')}}</el-button>
      </div>
    </div>
    <Dialog ref="dialog"></Dialog>
    <Detail ref="detail" :resultData="resultData"></Detail>
  </div>
</template>

<script>
import api from "@/api/api";
import tiktokApi from "@/api/moudles/tiktok";
import List from "./list";
import Dialog from "./component/dialog";
import Detail from "./detail";
import utils from "../../../../utils/utils";
import { resolve } from "path";
import { log } from "util";
export default {
  data() {
    return {
      tiktokShops: [],
      userId: null,
      shopId: null,
      categorylist: [],
      shopName: null,
      categorylistTwo: [],
      categorylistThree: [],
      categorylistfour: [],
      categorylistfive: [],
      categoryname: [],
      categoryId: [],
      conut: 0,
      hideCategory: false,
      showFormula: false,
      templeData: [],
      setFromul: false,
      dataList: [],
      showDrawer: false,
      formula: {
        outBoundFee: null,
        rate: null,
        area: null,
        profitRate: null,
        discount: null
      },
      country: null,
      tiktopshopsInfo: [],
      timer: null,
      resultData: [],
      showLoading: false
    };
  },
  components: {
    List,
    Dialog,
    Detail
  },
  created() {
    let tiktopshops = JSON.parse(localStorage.getItem("userInfo")).tiktokShops;
    this.tiktopshopsInfo = tiktopshops;
    let shops = JSON.parse(localStorage.getItem("userInfo"));
    this.userId = shops ? shops.userId : null;
    this.shopeeshops = shops ? shops.shopeeShops : [];
    this.productIds = [1, 2];

    this.dataList = [];
    utils
      .getInfoByCache({
        userId: this.userId,
        cacheKey: "TKS_MASS_ID"
      })
      .then(res => {
        this.productIds = res;
        let that = this;
        let list = [];

        this.productIds.forEach(p => {
          list.push(that.getModelInfo(p));
        });
        Promise.all(list).then(res => {
          this.templeData = res;
          console.log("templeData", this.templeData);
          if (res.length) {
            res.forEach((p, index) => {
              let variations = !!p.variations ? p.variations : [];
              let num = variations.length;

              p.skus = [];
              if (variations.length) {
                p.variations.forEach((i, indexTwo) => {
                  this.dataList.push({
                    ...i,
                    image: !!p.images ? p.images[0].image : null,
                    productId: p.productId,
                    image: !!p.tiers ? p.tiers[0].images[i.tierIndex[0]] : null,
                    rowSpan: indexTwo == 0 ? num : 0,
                    supplyPrice: JSON.parse(JSON.stringify(i.price))
                  });
                });
              }
            });

            this.getUserFormula();
          }
        });
      });
    if (tiktopshops) {
      this.tiktokShops = tiktopshops.map(p => {
        return {
          label: p.shopName,
          value: p.shopId
        };
      });
    }
  },
  methods: {
    //此方法会在母模版下保存一分子模版在children里面，不会影响母模版的信息
    updataModelData(params) {
      return new Promise(resolve => {
        api.updataProduct(params).then(res => {
          if (res.code === 200) {
            resolve(res.data);
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    //调用批量发布后，轮询发布状态
    getStatus(params) {
      api.getStatusTikTokPublish(params).then(res => {
        if (res.code === 200) {
          let total = res.data.total;
          let failed = res.data.failed ? res.data.failed : [];
          let success = res.data.success ? res.data.success : [];
          let isDone = success.length + failed.length === total ? true : false;
          if (isDone) {
            this.resultData = failed;
            this.$refs.detail.showDrawer = true;
            success.forEach(p => {
              p.success = true;
              p.message=this.$t('other.a3099')
              this.resultData.push(p);
            });

            console.log("轮询发布状态",this.resultData);
          } else {
            setTimeout(() => {
              this.getStatus(params);
            }, 2000);
          }
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //批量保存模版信息，并调用发布接口
    updateTemple(params) {
      let list = [];
      this.templeData.forEach(p => {
        p.country = this.country;
        p.categoryId = this.categoryId[this.categoryId.length - 1];
        p.itemSku = utils.randomString(12);
        p.productShops = [
          {
            shopId: this.shopId
          }
        ];
        p.variations.forEach(i => {
          let ttp = this.dataList.find(item => item.cusCode == i.cusCode);
          i.price = ttp ? ttp.price : i.price;
          i.price = Number(i.price);
        });
        let params = JSON.parse(JSON.stringify(p));
        params.modelId = p.productId;
        params.productId = null;
        list.push(this.updataModelData(params));
      });
      Promise.all(list).then(res => {
        console.log("999", res);
        let newParams = {
          categoryId: this.categoryId[this.categoryId.length - 1],
          country: this.country,
          productIds: res.map(p => {
            return p.productId;
          }),
          shopId: this.shopId,
          userId: this.userId
        };
        api.massPublishTiktop(newParams).then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.getStatus({
              requestId: res.data.requestId
            });
          } else {
            this.$message.warning(res.msg);
          }
        });
        console.log("newParams", this.newParams);
      });

      console.log("params", params);
      console.log("templeData", this.templeData);
    },
    saveTempleInfo() {
      this.$refs.listRef.updateModel();
      this.$refs.detail.showDrawer = true;
    },
    //清除用户的公式
    canCelFormula() {
      utils.updateInfoByCache({
        cacheKey: "tiktokFormula",
        userId: this.userId,
        cacheData: null
      });
      this.dataList.forEach(p => {
        p.price = p.supplyPrice;
      });
      this.showFormula = false;
      this.setFromul = false;
    },
    //获取用户的设定公式
    getUserFormula() {
      let ttp = null;
      utils
        .getInfoByCache({
          cacheKey: "tiktokFormula",
          userId: this.userId
        })
        .then(res => {
          if (res !== null) {
            let obj = res;
            this.setFromul = obj == null ? false : true;
            this.formula = res;
            console.log('formula',this.formula);
            this.dataList.forEach(p => {
              p.price =
                ((p.supplyPrice + obj.outboundfee) / obj.rate) / (1-obj.profitRate/100);
              p.price = p.price / (1 - obj.discount / 100);
              p.price = p.price.toFixed(2);
            });
          }
        });
    },
    countPrice() {
      console.log(this.dataList);
      console.log(this.formula);
      let obj = JSON.parse(JSON.stringify(this.formula));
      let params= JSON.parse(JSON.stringify(this.formula))
      obj.outboundfee = Number(obj.outBoundFee);
      obj.discount = Number(obj.discount);
      obj.rate = Number(obj.rate);
      obj.profitRate = Number(obj.profitRate) / 100 ;
      setTimeout(() => {
        this.dataList.forEach(p => {
          p.price =
            ((p.supplyPrice + obj.outboundfee) / obj.rate) / (1-obj.profitRate);
          p.price = p.price / (1 - obj.discount / 100);
          p.price = p.price.toFixed(2);
        });
        console.log("dataList", this.dataList);
        this.showFormula = false;
        this.setFromul = true;
      }, 500);

      utils.updateInfoByCache({
        cacheKey: "tiktokFormula",
        userId: this.userId,
        cacheData: JSON.stringify(params)
      });
    },

    getModelInfo(id) {
      return new Promise((resolve, reject) => {
        api
          .getProductByproductId({
            productId: id
          })
          .then(res => {
            if (res.code == 200) {
              resolve(res.data);
            }
          });
      });
    },

    publish() {
      if (!this.categoryId[0]) {
        this.$message.warning(this.$t('other.a2885'));
        return;
      }
      let shopeeshops = JSON.parse(localStorage.getItem("userInfo"))
        .shopeeShops;
      let shopTarget = this.tiktokShops.find(item => item.value == this.shopId);
      let params = {
        shopId: this.shopId,
        shopName: shopTarget.label,
        categoryname: this.categoryname,
        categoryId: this.categoryId,
        country: null
      };

      localStorage.setItem("addLazada", JSON.stringify(params));
      //判断是否从是仓库单品发布
      if (this.$route.query.from == "single") {
        //仓库单品发布到tiktok
        this.$router.push({
          path: "/tiktokShop",
          query: {
            productId: this.$route.query.id,
            groupId: this.$route.query.groupId,
            type: "TikTok Shop"
          }
        });
      } else {
        //我已处理 发布到tiktok
        this.$router.push({
          path: "/addGoods",
          query: {
            productId: this.$route.query.id,
            groupId: this.$route.query.groupId,
            type: "TikTok Shop"
          }
        });
      }
    },
    addItem(item, num) {
      console.log(item, num);
      if(!item.children){
        this.getCateDesc(item,num)
        return
      }
      let category = item.children;
      let list = null;
      category
        ? (list = category.map(p => {
            return p.localDisplayName;
          }))
        : (list = []);
      if (list) {
        this.getTransferCategory(list).then(res => {
          console.log(res);

          category.forEach((p, index) => {
            p.localDisplayName = res[index];
          });

          item.children = category;
          this.getCateDesc(item,num)
        });
      }
    },

    //类目

    getCateDesc(item,num) {
      

      if (num == 1) {
        this.categorylistTwo = item.children;
        this.categorylistThree = [];
        this.categorylistfour = [];
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }
      if (num == 2) {
        this.categorylistThree = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }
      if (num == 3) {
        this.categorylistfour = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      if (num == 4) {
        this.categorylistfive = item.children;
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      if (num == 5) {
        this.$set(this.categoryname, num - 1, item.localDisplayName);
        this.$set(this.categoryId, num - 1, item.id);
      }

      this.categoryname.forEach((p, index) => {
        if (index > num - 1) {
          this.$set(this.categoryname, index, null);
          this.$set(this.categoryId, index, null);
        }
      });
    },

    addLocalDisplayName(arr) {
      // 先判断传入的是否是数组，避免报错
      if (!Array.isArray(arr)) return []

      // 循环处理每一项
      return arr.map(item => {
        // 深拷贝，避免修改原始数据（重要！）
        const newItem = { ...item }

        // 为当前项添加 localDisplayName 字段
        // 这里可以自定义字段值规则，示例：使用name字段值
        newItem.localDisplayName = newItem.localName || ''

        // 判断是否有 children 且是数组，如果有则递归处理
        if (newItem.children && Array.isArray(newItem.children)) {
          newItem.children = this.addLocalDisplayName(newItem.children)
        }

        return newItem
      })
    },
    getCategory() {
      let targetShops = this.tiktopshopsInfo.find(
        p => p.shopId === this.shopId
      );
      this.country = targetShops ? targetShops.region : null;

      tiktokApi
        .getTikTokCategory({
          shopId: this.shopId,
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            res.data.children = this.addLocalDisplayName(res.data.children);
            console.log(res.data.children)
            let category = res.data.children;
            let list = null;
            res.data.children
              ? (list = res.data.children.map(p => {
                  return p.localDisplayName;
                }))
              : (list = []);
            if (list) {
              this.getTransferCategory(list).then(res => {
                category.forEach((p, index) => {
                  p.localDisplayName = res[index];
                });
                this.categorylist = category;
              });
            }
          } else {
          }
        });
    },

    getTransferCategory(params) {
      return new Promise(resolve => {
        tiktokApi.getTransfer(params).then(res => {
          if (res.code === 200) {
            resolve(res.data.resultMap);
          } else {
            console.log(res.msg);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";
.publishLazad {
  margin-top: $top_header_height;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .center {
    // position: absolute;
    // left: 0;
    // right: 0;
    // margin: 0 auto;

    width: 1248px;
    // background-color: #eee;
    height: calc(100vh - 50px);

    .iopr {
      margin-top: 20px;
    }

    .cateGory {
      cursor: pointer;
      color: #409eff;
      margin-left: 10px;
    }

    h2 {
      margin-top: 20px;
    }

    .categoryDesc {
      background-color: #f7f8fa;
      margin-top: 20px;
      padding: 10px 0;
      display: flex;
      align-items: center;
    }

    .okvn {
      width: 100px;
    }

    .categoryname {
      margin: 0 15px;
    }

    .desctext {
      font-size: 20px;
      color: #757575;
      padding: 10px 0;
    }

    .categoryWrapper {
      display: flex;
      margin-top: 15px;
      width: 1258px;
      overflow: hidden;
      overflow-x: scroll;
    }

    .footer {
      position: fixed;
      text-align: center;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 15px 0;
      height: 40px;
      background-color: #eee;
    }

    .hgfb {
      padding: 20px 0;
    }

    .tips {
      color: red;
      margin-left: 20px;
    }

    .ingk {
      padding: 5px 0;
      cursor: pointer;
    }

    .ingk:hover {
      background-color: #edf7ff;
    }

    .bkng {
      float: right;
      width: 0;
      height: 0;
      border-top: 5px solid transparent;
      border-left: 5px solid #dadada;
      border-bottom: 5px solid transparent;
      position: relative;
      top: 6px;
      right: 15px;
    }

    .boxwrapper {
      width: 312px;
      height: 356px;
      overflow: hidden;
      border: 1px solid #dbdbdb;
    }

    .name {
      font-size: 12px;
      padding-left: 15px;
    }
  }

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}
</style>